import { Injectable } from '@angular/core';
/**
 * @return {?}
 */
function getWindow() {
    return window;
}
var AmdWindowRef = /** @class */ (function () {
    function AmdWindowRef() {
    }
    Object.defineProperty(AmdWindowRef.prototype, "nativeWindow", {
        /**
         * @return {?}
         */
        get: function () {
            return getWindow();
        },
        enumerable: true,
        configurable: true
    });
    AmdWindowRef.decorators = [
        { type: Injectable },
    ];
    /**
     * @nocollapse
     */
    AmdWindowRef.ctorParameters = function () { return []; };
    return AmdWindowRef;
}());
export { AmdWindowRef };
function AmdWindowRef_tsickle_Closure_declarations() {
    /** @type {?} */
    AmdWindowRef.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    AmdWindowRef.ctorParameters;
}
//# sourceMappingURL=window-ref.service.js.map
//# sourceMappingURL=window-ref.service.js.map
